import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { District } from '@ascschool/model/category/district.model';
import { SystemUser } from '@ascschool/model/user/system-user.model';
import { SystemUserService } from '@ascschool/services/user/system-user.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
@Component({
  selector: 'app-doi-mat-khau',
  templateUrl: './doi-mat-khau.component.html',
  styleUrls: ['./doi-mat-khau.component.scss']
})
export class DoiMatKhauComponent implements OnInit {
  @Input() value: any;
  isEditMode = false;
  district = new District();
  errorMsg: string;
  isDisabled = false;
  validateForm = this.fb.group({
    oldPassword: [null, [Validators.required]],
    password: [null, [Validators.required]],
    confirmPassword: [null, [Validators.required]],
  }, {
    validator: this.MustMatch('password', 'confirmPassword')
  });
  user: SystemUser = new SystemUser();
  userId: string;
  constructor(
    public utilsService: UtilsService,
    private service: SystemUserService,
    private fb: FormBuilder,
    private authQuery: AuthQuery,
    private drawerRef: NzDrawerRef,
  ) {
  }

  ngOnInit() {
    this.authQuery.user$
      .subscribe(arg => {
        this.userId = arg.uid;
      });

  }
  UpdateChange() {
    if(this.validateForm.valid){
      this.user = this.validateForm.value;
      const obj = {
        userId : this.userId,
        oldPassword : this.utilsService.md5Encode(this.user.oldPassword),
        password : this.utilsService.md5Encode(this.user.password),
        confirmPassword : this.utilsService.md5Encode(this.user.confirmPassword),
      };
      this.service.changePassword(obj).subscribe((result: any) => {
      if (result.statusCode === 0) {
        this.utilsService.notifyResponse(result);
        this.close();
      } else {
        this.utilsService.notifyResponse(result);
      }
      });
    }
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
	}
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.drawerRef.close(true);
  }
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
}
